var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EChart',{attrs:{"card":"","header":_vm.$t('overview'),"loading":_vm.loading || _vm.isSpacesLoading,"error":_vm.error,"type":"time","height":"380","options":_vm.eChartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }